// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__Kap1p","buttons":"SendReceipts_buttons__29VwI","email":"SendReceipts_email__Bs2JW","bookApptTitle":"SendReceipts_bookApptTitle__1rCZ9"};